import * as React from "react";
import { Input } from "./input"; // өөрийн Input-оо импортлоно
import { Eye, EyeOff, Lock } from "lucide-react";

export function PasswordInput({ value, onChange, ...props }) {
    const [show, setShow] = React.useState(false);

    return (
        <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
                type={show ? "text" : "password"}
                value={value}
                onChange={onChange}
                className="pl-11 pr-10"
                {...props}
            />

            <button
                type="button"
                onClick={() => setShow(!show)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
                {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
        </div>
    );
}